require("slick-carousel");

const { AdsServicesMarquee } = require("../../components/ads-services-marquee");

const initPostSmarterSlider = () => {
  const slider = $("#post-smarter-slider");

  slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    dots: true,
    arrows: true,
    autoplay: true,
    duration: 2000,
    draggable: true,
    prevArrow:
      '<div class="post-smarter__slider-arrow post-smarter__slider-arrow--prev" aria-label="Previous"><i class="far fa-chevron-left" aria-hidden="true"></i></div>',
    nextArrow:
      '<div class="post-smarter__slider-arrow post-smarter__slider-arrow--next" aria-label="Next"><i class="far fa-chevron-right" aria-hidden="true"></i></div>',
    customPaging: function (slider, i) {
      return '<div class="post-smarter__slider-dot" aria-label="Go to slide ' + (i + 1) + '"></div>';
    },
    dotsClass: "post-smarter__slider-dots",
  });
};

document.addEventListener("DOMContentLoaded", () => {
  const adsServicesMarquee = new AdsServicesMarquee();
  
  adsServicesMarquee.initMarquee();
  initPostSmarterSlider();
});